import { Table } from '@Types/Table.types';

export type Column = {
  key: string;
  header: string;
};

export const toggleColumn = (columns: Column[], columnKey: string, allColumns: Column[]): Column[] => {
  const columnExists = columns.some((col) => col.key === columnKey);

  if (columnExists) {
    return columns.filter((col) => col.key !== columnKey);
  }

  const columnToAdd = allColumns.find((col) => col.key === columnKey);
  return columnToAdd ? [...columns, columnToAdd] : columns;
};

export const transformColumnStructure = (columns: Table[]) =>
  Object.values(columns).map((column) => ({
    label: column.header,
    value: column.key,
  }));
